import {
	MenuOutlined,
	CloseOutlined,
	HomeOutlined,
	MedicineBoxOutlined,
	QuestionCircleOutlined,
	CalendarOutlined,
	MessageOutlined,
	ContainerOutlined,
	CarryOutOutlined,
	ClockCircleOutlined,
	UpOutlined,
	DownOutlined,
} from '@ant-design/icons';
import { Fragment, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { createPortal } from 'react-dom';
import cn from 'classnames';

import { I18nt } from 'utils';
import styles from './Layout.module.less';
import { paths } from 'config';
import goesLogo from 'assets/images/goes.logo.png';
import { useLayoutContext } from './LayoutContext';

interface MenuItems {
	title: string;
	to: string;
	icon: JSX.Element;
	subMenus?: MenuItems[];
}

const MobileMenu = () => {
	const location = useLocation();
	const { isOpen, setIsOpen, setSubMenu, isSubMenuOpen } = useLayoutContext();

	const elements: MenuItems[] = [
		{
			title: I18nt('inicio'),
			to: paths.home,
			icon: <HomeOutlined />,
		},
		{
			title: I18nt('citas_medicas'),
			to: paths.citas_medicas,
			icon: <CalendarOutlined />,
			subMenus: [
				{
					icon: <CarryOutOutlined />,
					title: I18nt('calendarizacion_citas'),
					to: paths.agendar_cita,
				},
				{
					icon: <ClockCircleOutlined />,
					title: I18nt('mis_citas'),
					to: paths.historial_citas,
				},
			],
		},
		{
			title: I18nt('reserva_de_medicamento'),
			to: paths.consultar_medicamentos,
			icon: <MedicineBoxOutlined />,
		},
		{
			title: I18nt('examenes_de_laboratorio'),
			to: paths.examenes_laboratorio,
			icon: <ContainerOutlined />,
		},
		{
			title: I18nt('preguntas_frecuentes'),
			to: paths.faq,
			icon: <QuestionCircleOutlined />,
		},
		{
			title: I18nt('compartenos_tu_opinion'),
			to: paths.contact,
			icon: <MessageOutlined />,
		},
	];

	const navLinkMobileClass = ({ isActive }: { isActive: boolean }) => {
		return `${isActive ? styles.linkActiveMobile : ''} ${styles.menuItemMobile
			}`;
	};

	const showIcon = () => {
		if (isOpen) {
			return (
				<div className={styles.icon} onClick={() => setIsOpen(false)}>
					<CloseOutlined className={styles.menuIcon} />
				</div>
			);
		}
		return (
			<div className={styles.icon} onClick={() => setIsOpen(true)}>
				<MenuOutlined className={styles.menuIcon} />
			</div>
		);
	};

	const showMenu = () => {
		const wrapperElement = document.getElementById('menu') as HTMLElement;
		const menuItem = (menuItem: MenuItems) => (
			<NavLink
				to={menuItem.to}
				key={menuItem.title}
				className={navLinkMobileClass}
			>
				{menuItem.icon}
				{menuItem.title}
			</NavLink>
		);
		return createPortal(
			<>
				<div
					className={cn(styles.menuMobile, {
						[styles.layerOpen]: isOpen,
					})}
				>
					<div className={styles.mobileMenuHeader}>
						<img src={goesLogo} alt={I18nt('goes_logo_alt')} />
					</div>
					<div className={styles.mobileItems}>
						{elements.map((item) => {
							if (item.subMenus && item.subMenus.length) {
								return (
									<Fragment key={item.title}>
										<span
											role='button'
											className={styles.menuItemMobile}
											onClick={(event) => {
												event.preventDefault();
												setSubMenu(item.to);
											}}
										>
											{item.icon}
											{item.title}
											<span className={styles.caretContainer}>
												{isSubMenuOpen(item.to) ? (
													<UpOutlined />
												) : (
													<DownOutlined />
												)}
											</span>
										</span>
										<div
											className={cn(styles.subMenu, {
												[styles.subMenuActive]: isSubMenuOpen(item.to),
											})}
										>
											{item.subMenus.map((sm) => menuItem(sm))}
										</div>
									</Fragment>
								);
							}
							return menuItem(item);
						})}
					</div>
				</div>
				<div
					onClick={() => setIsOpen(false)}
					className={cn(styles.closeLayer, {
						[styles.layerOpen]: isOpen,
					})}
				></div>
			</>,
			wrapperElement
		);
	};

	useEffect(() => {
		setIsOpen(false);
	}, [location]);

	return (
		<section>
			<div className={styles.menuToggle}>{showIcon()}</div>
			{showMenu()}
		</section>
	);
};

export default MobileMenu;
